import { NavBarBtnModel } from 'common/src/models';
import { MORE_ACTIONS_INLINE_THRESHOLD } from '../constants';

export interface PreviewFooterMoreAction {
  actionTitle: string;
  actionName: string;
  actionIcon: string;
  classes?: string;
  disabled?: boolean;
}

export function collapseMoreActionsIntoFooter(
  footerButtons: NavBarBtnModel[],
  moreActions: PreviewFooterMoreAction[],
): NavBarBtnModel[] {
  return footerButtons.reduce((footerActions, btn) => {
    if (btn.actionName !== 'moreActions') { return [...footerActions, btn]; }

    if (moreActions.length && moreActions.length <= MORE_ACTIONS_INLINE_THRESHOLD) {
      return [
        ...footerActions,
        ...moreActions.map(action => ({ ...btn, actions: [{ ...action, classes: btn.classes }] })),
      ];
    }
    return moreActions.length ? [...footerActions, { ...btn, actions: moreActions }] : footerActions;
  }, [] as NavBarBtnModel[]);
}
